import Errors from './Errors';
import axios from 'axios';

const token = document.head.querySelector('meta[name="csrf-token"]');

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

class Form {
  
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(data) {
    this.originalData = data;

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
    this.config = {};
  }

  /**
   * Fetch all relevant data for the form.
   * 
   * @return {object}
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }

  /**
   * Fetch original data
   * 
   * @return {object}
   */
  getOriginal () {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this.originalData[property];
    }

    return data;
  }

  /**
   * Compares data with original data and return if they differ or not
   * 
   * @return {Boolean}
   */
  isDirty () {
    return JSON.stringify(this.data()) !== JSON.stringify(this.getOriginal())
  }

  /**
   * Returns if data has given property
   * 
   * @param  {String}  property
   * @return {Boolean}
   */
  hasDataProperty(property) {
    if (this.originalData === undefined || this.originalData === null) {
      return false;
    }
    return this.originalData.hasOwnProperty(property);
  }

  /**
   * Reset the form fields.
   */
  reset() {
    for (let field in this.originalData) {
      if (Array.isArray(this[field])) {
        this[field] = []
      } else if (typeof this[field] === 'object') {
        this[field] = null
      } else {
        this[field] = ''
      }
    }

    this.errors.clear();
  }

  /**
   * Reset the form fields to original data.
   */
  resetToOriginal () {
    for (let field in this.originalData) {
      this[field] = this.originalData[field]
    }

    this.errors.clear()
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post(url) {
    return this.submit('post', url);
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put(url) {
    return this.submit('put', url);
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch(url) {
    return this.submit('patch', url);
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete(url) {
    return this.submit('delete', url);
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   */
  submit(requestType, url) {
    this.prepareData();
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data(), this.config)
        .then(response => {
          // TODO: remove data code check and resolve response.data
          if (response.data.code === 422) {
            // only call onFail on validation error
            this.onFail(response.data);  
          } else {
            this.onSuccess(response.data);
          }

          resolve(response);
        })
        .catch(error => {
          if (error.response === undefined || error.response === null) {
            reject(error)
          } else {
            if (error.response.status === 422) {
              // only call onFail on validation error
              this.onFail(error.response.data);  
            }
  
            reject(error.response);
          }
        });
    });
  }

  /**
   * Prepare data before submitting them to the backend. You can overwrite
   * this function and handle data based on rules etc.
   */
  prepareData () {}

  /**
   * Sets config for next request
   * 
   * @param {object} config
   */
  setConfig (config) {
    this.config = config;
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    // maybe useful later
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
  }
}

export default Form;

